<template>
    <div class="pb-12 overflow-y-auto h-full">
        <div
            class="px-4 lg:px-32 pb-16 pt-20 text-left lg:pt-32 bg-center bg-[linear-gradient(180deg,#d1f2fd,rgba(209,242,253,0))]">
            <h1
                class="font-display text-xl xl:text-2xl 2xl:text-4xl sm:text-4xl font-bold tracking-tight text-slate-900">
                专注于中小型非标机械厂的生产管理软件系统
            </h1>
            <h3 class="mt-12 text-base lg:text-xl tracking-wide text-slate-700">
                轻松解决中小型非标机械厂订单交期与库存管理难题
            </h3>
        </div>

        <div class="mx-4 lg:mx-24 xl:mx-64 py-8 text-center lg:py-16 border-y">
            <div class="customer-grid hidden lg:grid items-stretch gap-4 mt-6 text-base text-left">
                <div class="min-w-0 flex flex-col" v-for="item in users" :key="item.title">
                    <div class="customer-card-wrap flex flex-1 flex-col min-w-0">
                        <a-tooltip v-if="item.url">
                            <template slot="title">
                                点击查看详情
                            </template>
                            <a-card class="customer-card" :title="item.title" @click="openPage(item.url)">
                                <p class="font-[600] customer-desc">{{ item.desc }}</p>
                            </a-card>
                        </a-tooltip>
                        <a-card v-else class="customer-card" :title="item.title">
                            <p class="font-[600] customer-desc">{{ item.desc }}</p>
                        </a-card>
                    </div>
                </div>
            </div>
            <div class="flex flex-col lg:hidden justify-center mt-0">
                <a-row style="width: 100%;" class="mt-6" v-for="item in users" :key="item.title">
                    <a-card v-if="item.url" class="customer-card" :title="item.title" @click="openPage(item.url)">
                        <p class="font-[600]">{{ item.desc }}</p>
                    </a-card>
                    <a-card v-else class="customer-card" :title="item.title">
                        <p class="font-[600]">{{ item.desc }}</p>
                    </a-card>
                </a-row>
            </div>
        </div>

        <home-page-to-contact />
        <home-page-contact />
    </div>
</template>

<script>
import HomePageContact from './components/contact';
import HomePageToContact from './components/to-contact'

export default {
    name: 'homePageCustomer',
    components: {
        HomePageContact,
        HomePageToContact
    },
    data() {
        return {
            users: [
                {
                    title: '重庆航鼎精密',
                    desc: '“轻熵科技给我们非标定制的这款ERP&MES一体化管理系统还是不错的，超交期的订单能精确查到在哪个工位，停留多少时间。当天完成的货也能马上看到。每天客户下的订单什么时候到车间也能清楚。以后可以告别写黑板了。”',
                },
                {
                    title: '重庆吉盛刀具',
                    desc: '“用了轻熵科技的一体化ERP&MES系统后，最直观的感受是跟单、盯活节省了很多时间，可以去做其他的事情。系统可以通过扫码报工自动跟单，各环节数据实现了自动流转，极大减少非增值时间浪费，从而加快产品流转速度，缩短产品生产周期。现在我们算是生产管理理念和水平都很靠前的，我们的口碑和声誉也打出去了。”'
                },
                {
                    title: '某刀具制造',
                    desc: '“用数据驱动决策”',
                    url: 'https://mp.weixin.qq.com/s/IWe19XZJkIJXAKgZfJmuhg'
                },
                {
                    title: '长春某精密机械',
                    desc: '“员工不变，产值提升20%，订单准交率提升20%”',
                    url: 'https://mp.weixin.qq.com/s/66xdr2nTU9DVlT-EZbNJJA'
                },
            ],
        }
    },
    methods: {
        openPage(url) {
            window.open(url)
        }
    }
}
</script>
<style scoped>
.customer-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
}

.customer-card-wrap >>> span {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-width: 0;
}

.customer-card {
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 0;
}

.customer-card >>> .ant-card-body {
    flex: 1;
}

.customer-desc {
    word-break: break-word;
    overflow-wrap: anywhere;
    white-space: normal;
}

.customer-card:hover {
    cursor: pointer;
    color: #3e90ff;
    border-color: #3e90ff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .09);
}
</style>
